
import React, { memo } from 'react';
import { Trans } from 'react-i18next';
import useMiaEventMessageData from '../../../hooks/inbox/data/useMiaEventMessageData';

/**
 * MiaEventMessageMC - Atom
 * Mensaje de evento de MIA (actividad del bot o sistema)
 *
 * @param {Object} eventData - Datos del evento (agent_name, action)
 * @param {string|number|Date} timestamp - Fecha/hora del evento
 */
const MiaEventMessageMC = memo(({ message }) => {
  const { field, name, i18nKey, formattedDateTime } = useMiaEventMessageData({ message });

  return (
    <div className="tw-wrapper tw-flex tw-flex-col tw-items-center tw-w-full tw-my-2">
      <div className="tw-text-center tw-text-3xs">{formattedDateTime}</div>
      <div className="tw-border tw-border-gray-200 tw-py-3 tw-px-4 tw-text-center tw-bg-gray-50 tw-rounded tw-text-base tw-w-full">
        <Trans
          i18nKey={i18nKey}
          values={{ [field]: name }}
          components={{ strong: <strong /> }}
        />
      </div>
    </div>
  );
});

MiaEventMessageMC.displayName = 'MiaEventMessageMC';

export default MiaEventMessageMC;
